import React from 'react'
import './Counter.css';
import CountUp from 'react-countup';
import { counterData } from '../../data/counterData';

function Counter() {
    
    
  return (
    
<>

<div className="crow">
  <div className="ccolumn" >
    {/* <img src={paint} className="img"/> */}
    <p className='desc'>
    <CountUp start={0} enableScrollSpy='true' duration={5} delay={2} end={counterData.Experience} />&nbsp; Year(s)
    </p><br/>
    <p className='desc2'>Experience</p>
  </div>

  <div className="ccolumn" id='column2' >
  {/* <img src={travel} className="img"/> */}
  <p className='desc'>
    <CountUp start={0} enableScrollSpy='true' duration={5} delay={2} end={counterData.Projects} />
    </p><br/>
  <p className='desc2'>Projects</p>
  </div>

  <div className="ccolumn">
  {/* <img src={blog} className="img"/> */}
  <p className='desc'>
    <CountUp start={0} enableScrollSpy='true' duration={5} delay={2} end={counterData.Blogs} />
    </p><br/>
  <p className='desc2'>Blogs</p>
  </div>
</div>

</>

  )
}

export default Counter